import { SidebarLayout } from "components/layout/sidebar-layout";
import { Responsive } from "components/responsive";
import React from "react";
import { NgSidebar } from "./ng-sidebar";

interface NgContainerProps {
    children: React.ReactNode;
}

export const NgContainer: React.FC<NgContainerProps> = props => {
    return (
        <>
            <Responsive />
            <SidebarLayout sidebar={<NgSidebar />} navbar={null}>
                {props.children}
            </SidebarLayout>
        </>
    );
};
